import Reveal from "./Reveal";
import { useContent } from "../content";

export default function Manifesto() {
  const items = useContent().manifesto || [];
  if (items.length === 0) return null;
  return (
    <section id="manifeste" className="relative border-y border-white/10 bg-[#0a0a0a] py-24 sm:py-32" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-16">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">
            Pourquoi nous choisir
          </span>
          <h2 className="mt-4 max-w-3xl font-head text-4xl font-semibold uppercase tracking-tight text-white sm:text-5xl">
            Un engagement technique, sans compromis
          </h2>
        </Reveal>

        <div className="grid gap-px overflow-hidden rounded-md border border-white/10 bg-white/10 md:grid-cols-3">
          {items.map((m, i) => (
            <Reveal
              key={m.num + i}
              delay={i * 0.1}
              className="group bg-[#0a0a0a] p-8 transition-colors duration-300 hover:bg-[#111111] sm:p-10"
              data-testid={`manifesto-${m.num}`}
            >
              <span className="font-head text-6xl font-bold tracking-tighter text-gradient">
                {m.num}
              </span>
              <h3 className="mt-6 font-head text-2xl font-medium uppercase tracking-tight text-white">
                {m.title}
              </h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-white/60">{m.desc}</p>
              <span className="mt-6 block h-px w-12 bg-brand-gradient transition-[width] duration-500 group-hover:w-24" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
